import React, { Component } from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import classNames from 'classnames';
import * as validators from '../../util/validators';
import {
  Form,
  PrimaryButton,
  FieldRadioButton,
  FieldTextInput,
  NamedLink,
  FieldPhoneNumberInput,
  FieldPhoneNumberInputWithDialCode,
  FieldPassword,
  SecondaryButton,
  InlineTextButton,
  Modal,
  FieldNumberInput,
  FieldRadioButtonGroup,
  FieldCustomSelect,
  FieldCheckbox,
  FieldAddress,
  FieldRecaptcha,
  CustomRadioButton,
  FieldDateInput,
  FieldWorkerJobCategory,
  FieldWorkerExperience,
  FieldReference,
  FieldPermitAndCertificate,
  FieldPerferredLang,
  FieldCalendlyMeet,
} from '../../components';

import css from './SignupForm.module.css';
import { FormSpy } from 'react-final-form';
import { createResourceLocatorString } from '../../util/routes';
import routeConfiguration from '../../routeConfiguration';
import { apiBaseUrl } from '../../util/api';
import axios from '../../util/axiosHelper';
import { replaceNumberWithCharacter } from '../../util/richText';
import {
  age16PlusOptions,
  drivingLicenseOptions,
  listingTypes,
  minimumAgeRequired,
  sosAdOptions,
  workerAllowedOptions,
} from '../../marketplace-custom-config';
import { isEmpty } from 'lodash';
import { getDefaultTimeZoneOnBrowser } from '../../util/dates';
import DateInput from '../../components/FieldDateInput/DateInput';
import moment from 'moment';

const KEY_CODE_ENTER = 13;
const textfield = 'textfield';
const errorTextField = 'errorTextField';

const workagredOnTerms = 'yes';

export default class CustomerSignup extends Component {
  constructor(props) {
    super(props);
    this.recaptchRef = React.createRef();
    this.state = {
      showOtpModal: false,
      signStep: 0,
      otpValidationInProgress: false,
      showNotAllowedModal: false,
      notAllowedHeadingId: 'SignupForm.notAllowedHeading',
      notAllowedBodyId: 'SignupForm.notAllowedBody',
      isOtpValidated: false,
      isUserCreateInProgress: false,
      isUserCreated: false,
      hasUserCreateError: false,
      showCalendlyModal: false,
      otpResend: false,
    };
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.isEmailTakenError !== this.props.isEmailTakenError &&
      this.props.isEmailTakenError
    ) {
      const { formApi } = this.props;
      const {
        values: { email },
      } = formApi.getState();
      const entries = [['refEmail', email]];
      this.setState({ signStep: 0 });
      this.formBatchUpdate(entries);
      formApi.focus('email');
      setTimeout(() => formApi.blur('email'), 100);
    }
    this.createWorker();
    this.checkSignupError();
  }

  handleOnCancelBtnClick = () => {
    const { history } = this.props;
    history.replace(createResourceLocatorString('LandingPage', routeConfiguration()));
  };

  setShowOtpModal = status => {
    this.setState({ showOtpModal: status });
  };

  setShowNotAllowedModal = (
    status,
    headingId = 'SignupForm.notAllowedHeading',
    bodyId = 'SignupForm.notAllowedBody'
  ) => {
    this.setState({
      showNotAllowedModal: status,
      notAllowedHeadingId: headingId,
      notAllowedBodyId: bodyId,
    });
  };

  checkAndHideOtpModal = () => {
    if (this.state.otpValidationInProgress) return;
    this.setShowOtpModal(false);
  };

  requestForOtp = async () => {
    this.setShowOtpModal(true);
    try {
      const { formApi } = this.props;
      const { values } = formApi.getState();
      const {
        phoneNumber: { number, dialCode },
      } = values;
      const mobileNumber = `${dialCode}${number}`;
      const url = `${apiBaseUrl()}/api/user/generate/phoneotp/mobile`;
      await axios.post(url, { mobile: mobileNumber });
    } catch (err) {
      console.error(err);
    }
  };

  formBatchUpdate = (entries = []) => {
    const { formApi } = this.props;
    formApi.batch(() => {
      for (let entry of entries) {
        formApi.change(entry[0], entry[1]);
      }
    });
  };

  // formBatchAndDelayUpdate = (data, hasDelayUpdate = false, delayTimeout = 100) => {
  //   if (typeof data !== 'object' && data.constructor !== Object) return;
  //   const { batchUpdateData = {}, delayUpdateData = {} } = data;
  //   let entries = Object.entries(batchUpdateData);
  //   this.formBatchUpdate(entries);
  //   if (hasDelayUpdate && !isEmpty(delayUpdateData)) {
  //     entries = Object.entries(delayUpdateData);

  //     setTimeout(() => this.formBatchUpdate(entries), delayTimeout);
  //   }
  // };

  verifyOtp = async () => {
    if (this.state.otpValidationInProgress) return;
    this.setState({ otpValidationInProgress: true, isOtpValidated: false });
    const { formApi, onSubmit } = this.props;
    const { values } = formApi.getState();
    const {
      phoneNumber: { number, dialCode },
      otp,
    } = values;
    formApi.change('refOtp', '');
    try {
      const mobileNumber = `${dialCode}${number}`;
      const url = `${apiBaseUrl()}/api/user/validate/phoneotp/mobile`;
      await axios.post(url, { mobile: mobileNumber, otp });
      formApi.change('isPhoneNumberVerified', true);
      this.setState({ isOtpValidated: true });
    } catch (err) {
      const entries = [['refOtp', '-1'], ['customOtpErrTextId', 'SignupForm.invalidOtp']];
      this.formBatchUpdate(entries);
      formApi.focus('otp');
      setTimeout(() => formApi.blur('otp'), 100);
      this.setState({ otpValidationInProgress: false, isOtpValidated: false });
    }
  };

  handleRecaptchStatusChange = value => {
    const { recaptchaStatus } = value;
    const { formApi } = this.props;
    formApi.change('recaptchaStatus', { ...recaptchaStatus });
  };

  // handleFormSpyChange = formValues => {
  //   const { formApi } = this.props;
  //   const { values, active } = formValues;
  //   const { refOtp, refEmail, email } = values;
  //   // if (active && active.toLowerCase() === 'otp' && !isNaN(parseInt(refOtp))) {
  //   //   formApi.change('refOtp', '');
  //   // } else if (active && active.toLowerCase() === 'email' && !!refEmail && email !== refEmail) {
  //   //   formApi.change('refEmail', '');
  //   // }
  // };

  handleSubmit = event => {
    event.preventDefault();
    event.stopPropagation();
    const {
      formApi,
      onAddOrUpdateWorkerExtraDetails,
      error,
      currentSignupUser,
      currentSignupUserLoaded,
      onUpdateProfile,
      userNativeLang,
      onSubmit,
    } = this.props;
    if (!isEmpty(error)) return;
    const { values } = formApi.getState();
    const {
      age16Plus,
      workerAllowed,
      // birthdate,
      email,
      interviewDetails,
      jobCategories,
      jobExperiences,
      references,
      permitsAndCertificates,
      preferredLang,
      recaptchaStatus = {},
      password,
      lname,
      fname,
    } = values;

    const { hasRecaptchaValidated = false } = recaptchaStatus;
    if (!hasRecaptchaValidated) return;
    const hasValidValue =
      workerAllowed === workerAllowedOptions.yes.value && age16Plus === age16PlusOptions.yes.value;

    // &&
    // birthdate &&
    // birthdate.date &&
    // birthdate.date instanceof Date;

    const hasInterviewDetails =
      interviewDetails &&
      interviewDetails.eventUri &&
      interviewDetails.inviteeUri &&
      interviewDetails.isConfirmed;

    if (!hasValidValue) return;
    if (this.state.signStep === 0) {
      const { isPhoneNumberVerified } = values;
      if (isPhoneNumberVerified) {
        this.setState(
          {
            isUserCreateInProgress: false,
            isUserCreated: false,
            hasUserCreateError: false,
            isOtpValidated: true,
            signStep: 0,
          },
          this.createWorker
        );
      } else {
        if (this.state.showOtpModal) {
          this.verifyOtp();
        } else {
          axios
            .post(
              `${apiBaseUrl()}/api/user/ExistingUserStatus`,
              {
                email,
                userNativeLang,
              },
              { withCredentials: true }
            )
            .then(res => {
              if (res?.data === 'yes') {
                onSubmit({
                  email,
                  password,
                  lname,
                  fname,
                });
              }
            })
            .catch(err => {
              if (err?.response?.status === 404) {
                this.requestForOtp();
              }
            });
        }
      }
    } else if (this.state.signStep === 1) {
      if (!hasInterviewDetails) {
        this.setState({ showCalendlyModal: false }, () => {
          setTimeout(() => {
            this.setState({ showCalendlyModal: true });
          }, 100);
        });
      }

      if (hasInterviewDetails && currentSignupUserLoaded) {
        const workerDetails = {
          isUpdate: false,
          userId: currentSignupUser.id.uuid,
          jobCategories,
          preferredLang: preferredLang.value,
          interviewDetails,
          ...(jobExperiences && jobExperiences.length > 0 ? { jobExperiences } : {}),
          ...(references && references.length > 0 ? { references } : {}),
          ...(permitsAndCertificates && permitsAndCertificates.length > 0
            ? { permitsAndCertificates }
            : {}),
        };
        const searchCategory = jobCategories.map(m => m.category);
        const searchSubCategory = jobCategories.map(m => m.subCategory);
        const profile = {
          publicData: {
            searchCategory,
            searchSubCategory,
          },
        };
        const updatedValue = { ...profile };

        onUpdateProfile(updatedValue);

        onAddOrUpdateWorkerExtraDetails(workerDetails);
      }
    }
  };

  handleWorkerAllowedChange = value => {
    const { formApi } = this.props;
    formApi.change('workerAllowed', value);
    if (value === workerAllowedOptions.no.value) {
      this.setShowNotAllowedModal(true);
    }
  };
  handleAge16PlusChange = value => {
    const { formApi } = this.props;
    formApi.change('age16Plus', value);
    if (value === workerAllowedOptions.no.value) {
      this.setShowNotAllowedModal(
        true,
        'SignupForm.not16YearOldHeading',
        'SignupForm.not16YearOldBody'
      );
    }
  };

  handleDrivingLicenseChange = value => {
    const { formApi } = this.props;
    formApi.change('drivingLicense', value);
  };

  createWorker = async () => {
    if (
      this.state.isOtpValidated &&
      !this.props.inProgress &&
      !this.state.isUserCreateInProgress &&
      !this.state.isUserCreated &&
      !this.state.hasUserCreateError
    ) {
      this.setState({
        isUserCreateInProgress: true,
        isUserCreated: false,
        hasUserCreateError: false,
      });
      const { formApi, onSubmit } = this.props;
      const { values } = formApi.getState();
      formApi.change('refEmail', '');
      const {
        phoneNumber,
        fname,
        lname,
        email,
        password,
        workerAddress,
        preferredLang,
        // birthdate,
        workerAllowed,
        drivingLicense,
        age16Plus,
        workerAgrement,
        jobCategories,
      } = values;
      const displayName = fname + lname;
      const CreateKeyword = location => {
        const newlocationArr = [];
        const locationLength = location.length;
        for (let i = 1; i <= locationLength; i++) {
          newlocationArr.push(location.substring(0, i));
        }
        return newlocationArr;
      };

      const { number: num, iso2, iso3, dialCode: dcode } = phoneNumber;
      const publicData = {
        // name: fname.toLowerCase() + lname.toLowerCase(),
        // searchJobcategory: jobCategories.map(m => m.category),
        // searchJobcategory: jobCategories.map(m => m.subCategory),
        searchAddressForWorker: [
          ...CreateKeyword(
            workerAddress?.address
              .trim()
              .replace(/[,\s]/g, '')
              .toLowerCase()
          ),
        ],
        searchNameForWorker: [
          ...CreateKeyword(
            displayName
              .trim()
              .replace(/[,\s]/g, '')
              .toLowerCase()
          ),
        ],
        workerAddress,
        workerAllowed,
        drivingLicense,
        age16Plus,
        workerAgrement: workerAgrement[0],
        isProvider: false,
        preferredLang,
      };
      const protectedData = {
        // birthdate: birthdate.date.toISOString(),
        phoneNumber: { number: num, iso2, iso3, dialCode: dcode },
        isPhoneNumberVerified: true,
        isSocialSignup: false,
        timeZone: getDefaultTimeZoneOnBrowser(),
      };

      const updatedValues = { email, password, lname, fname, publicData, protectedData };
      await onSubmit(updatedValues);
    }
  };

  checkSignupError = () => {
    if (this.state.isUserCreateInProgress) {
      if (!!this.props.signupErrorMessage) {
        this.setState({
          otpValidationInProgress: false,
          isUserCreateInProgress: false,
          hasUserCreateError: true,
          showOtpModal: false,
          signStep: 0,
        });
      } else if (
        !this.props.signupErrorMessage &&
        this.props.isAuthenticated &&
        this.props.currentSignupUserLoaded
      ) {
        this.setState({
          otpValidationInProgress: false,
          isUserCreateInProgress: false,
          isUserCreated: true,
          showOtpModal: false,
          signStep: 1,
        });
      }
    }
  };

  handleOnSkipBtnClick = e => {
    e.preventDefault();
    const { onFetchCurrentUser } = this.props;
    onFetchCurrentUser();
  };

  handleCalendlyMeetChange = values => {
    const { formApi } = this.props;
    formApi.change('interviewDetails', values);
  };

  render() {
    const {
      values,
      intl,
      inProgress,
      invalid,
      formId,
      rootClassName,
      className,
      onManageDisableScrolling,
      userNativeLang,
      signupErrorMessage,
      isEmailTakenError,
      formApi,
      error,
      socialLoginButtonsMaybe,
    } = this.props;

    const firstNameId = formId ? `${formId}.fname` : 'fname';
    const lastNameId = formId ? `${formId}.lname` : 'lname';
    const emailId = formId ? `${formId}.email` : 'email';
    const phoneNumberId = formId ? `${formId}.phoneNumber` : 'phoneNumber';
    const passwordId = formId ? `${formId}.password` : 'password';
    const confirmPasswordId = formId ? `${formId}.confirmPassword` : 'confirmPassword';
    const recaptchaId = formId ? `${formId}.recaptchaStatus` : 'recaptchaStatus';
    const workerAddressId = formId ? `${formId}.workerAddress` : 'workerAddress';
    const workerAllowedOptionsId = formId
      ? `${formId}.workerAllowedOptions`
      : 'workerAllowedOptions';

    const drivingLicenseOptionsId = formId
      ? `${formId}.drivingLicenseOptions`
      : 'drivingLicenseOptions';

    const age16PlusOptionsId = formId ? `${formId}.age16PlusOptions` : 'age16PlusOptions';
    const birthdateId = formId ? `${formId}.birthdate` : 'birthdate';
    const workerAgreementId = formId ? `${formId}.workerAgreement` : 'workerAgreement';
    const jobCategoryId = formId ? `${formId}.jobCategories` : 'jobCategories';
    const jobExpId = formId ? `${formId}.jobExperiences` : 'jobExperiences';
    const referId = formId ? `${formId}.references` : 'references';
    const certificateId = formId ? `${formId}.permitsAndCertificates` : 'permitsAndCertificates';
    const preferredLangId = formId ? `${formId}.preferredLang` : 'preferredLang';
    const interviewDetailsId = formId ? `${formId}.interviewDetails` : 'interviewDetails';
    const {
      lname = '',
      fname = '',
      email = '',
      password = '',
      phoneNumber,
      refEmail = '',
      refOtp = '',
      recaptchaStatus = {},
      workerAllowed,
      drivingLicense,
      age16Plus,
      jobCategories = [],
      workerAgrement = [],
      interviewDetails = {},
      otp,
      customOtpErrTextId,
    } = values;
    const { dialCode, number = '' } = phoneNumber;
    const phoneNumberWithDialCode = `${dialCode} ${replaceNumberWithCharacter(number, 'X')}`;
    const { hasRecaptchaValidated = false } = recaptchaStatus;
    const classes = classNames(rootClassName || css.root, className);
    const submitInProgress = inProgress;
    const isFormOtherFieldInvalid =
      invalid ||
      workerAllowed === workerAllowedOptions.no.value ||
      age16Plus === age16PlusOptions.no.value ||
      (workerAgrement && workerAgrement[0] !== workagredOnTerms);
    const reacaptchaInitialValueMaybe =
      recaptchaStatus &&
      typeof recaptchaStatus.hasRecaptchaValidated !== 'undefined' &&
      typeof recaptchaStatus.isRecaptchaInvalid !== 'undefined'
        ? { initialValue: recaptchaStatus }
        : {};

    const interviewDetailsMaybe =
      interviewDetails && interviewDetails.name && interpreterDetails.email
        ? interviewDetails
        : lname && fname && email
        ? { name: `${fname} ${lname}`, email }
        : { name: '', email: '' };
    // console.log(969, interviewDetailsMaybe);

    const submitDisabled = isFormOtherFieldInvalid || submitInProgress || !hasRecaptchaValidated;
    // email
    const emailLabel = intl.formatMessage({
      // id: 'SignupForm.emailLabel',
      id: 'ContactUsForm.emailLabel',
    });
    const emailPlaceholder = intl.formatMessage({
      id: 'SignupForm.emailPlaceholder',
    });
    const emailRequiredMessage = intl.formatMessage({
      id: 'SignupForm.emailRequired',
    });
    const emailRequired = validators.required(emailRequiredMessage);
    const emailInvalidMessage = intl.formatMessage({
      id: 'SignupForm.emailInvalid',
    });
    const emailExistMessage = intl.formatMessage({
      id: 'SignupForm.emailExist',
    });
    const emailValid = validators.emailFormatValid(emailInvalidMessage);
    const emailExist = validators.isEmailExist(emailExistMessage, refEmail);
    const emailValidator = validators.composeValidators(emailRequired, emailValid, emailExist);

    // password
    const passwordLabel = intl.formatMessage({
      id: 'SignupForm.passwordLabel',
    });
    const passwordPlaceholder = intl.formatMessage({
      id: 'SignupForm.passwordPlaceholder',
    });
    const passwordRequiredMessage = intl.formatMessage({
      id: 'SignupForm.passwordRequired',
    });
    const passwordMinLengthMessage = intl.formatMessage(
      {
        id: 'SignupForm.passwordTooShort',
      },
      {
        minLength: validators.PASSWORD_MIN_LENGTH,
      }
    );
    const passwordMaxLengthMessage = intl.formatMessage(
      {
        id: 'SignupForm.passwordTooLong',
      },
      {
        maxLength: validators.PASSWORD_MAX_LENGTH,
      }
    );

    const passwordRegexRequiredMessage = intl.formatMessage({
      id: 'SignupForm.passwordRegexRequired',
    });
    const passwordMinLength = validators.minLength(
      passwordMinLengthMessage,
      validators.PASSWORD_MIN_LENGTH
    );
    const passwordMaxLength = validators.maxLength(
      passwordMaxLengthMessage,
      validators.PASSWORD_MAX_LENGTH
    );

    const passwordRegexRequired = validators.validatePasswordRegex(passwordRegexRequiredMessage);
    const passwordRequired = validators.requiredStringNoTrim(passwordRequiredMessage);
    const passwordValidators = validators.composeValidators(
      passwordRequired,
      passwordRegexRequired,
      passwordMinLength,
      passwordMaxLength
    );

    // confirm password
    const confirmPasswordLabel = intl.formatMessage({
      id: 'SignupForm.confirmPasswordLabel',
    });
    const confirmPasswordPlaceholder = intl.formatMessage({
      id: 'SignupForm.confirmPasswordPlaceholder',
    });
    const confirmPasswordRequiredMessage = intl.formatMessage({
      id: 'SignupForm.passwordRequired',
    });
    const confirmPasswordMinLengthMessage = intl.formatMessage(
      {
        id: 'SignupForm.passwordTooShort',
      },
      {
        minLength: validators.PASSWORD_MIN_LENGTH,
      }
    );
    const confirmPasswordMaxLengthMessage = intl.formatMessage(
      {
        id: 'SignupForm.passwordTooLong',
      },
      {
        maxLength: validators.PASSWORD_MAX_LENGTH,
      }
    );
    const passwordNotEqualConfirmMessage = intl.formatMessage({
      id: 'SignupForm.confirmPasswordNotEqual',
    });
    const confirmPasswordMinLength = validators.minLength(
      confirmPasswordMinLengthMessage,
      validators.PASSWORD_MIN_LENGTH
    );
    const confirmPasswordMaxLength = validators.maxLength(
      confirmPasswordMaxLengthMessage,
      validators.PASSWORD_MAX_LENGTH
    );
    const confirmPasswordRequired = validators.requiredStringNoTrim(confirmPasswordRequiredMessage);
    const isConfirmPasswordEqualPassword = validators.isEqual(
      passwordNotEqualConfirmMessage,
      password
    );
    const confirmPasswordValidators = validators.composeValidators(
      confirmPasswordRequired,
      passwordRegexRequired,
      isConfirmPasswordEqualPassword,
      confirmPasswordMinLength,
      confirmPasswordMaxLength
    );

    // firstName
    const firstNameLabel = intl.formatMessage({
      id: 'SignupForm.firstNameLabel',
    });
    const firstNamePlaceholder = intl.formatMessage({
      id: 'SignupForm.firstNamePlaceholder',
    });
    const firstNameRequiredMessage = intl.formatMessage({
      id: 'SignupForm.firstNameRequired',
    });
    const firstNameRequired = validators.required(firstNameRequiredMessage);

    // lastName
    const lastNameLabel = intl.formatMessage({
      id: 'SignupForm.lastNameLabel',
    });
    const lastNamePlaceholder = intl.formatMessage({
      id: 'SignupForm.lastNamePlaceholder',
    });
    const lastNameRequiredMessage = intl.formatMessage({
      id: 'SignupForm.lastNameRequired',
    });
    const lastNameRequired = validators.required(lastNameRequiredMessage);

    // phone number
    const phoneNumberLabel = intl.formatMessage({
      id: 'SignupForm.phoneNumbeLabel',
    });
    const phoneNumberPlaceholder = intl.formatMessage({
      id: 'SignupForm.phoneNumbePlaceholder',
    });
    const phoneNumberRequiredMessage = intl.formatMessage({
      id: 'SignupForm.phoneNumbeRequired',
    });
    const phoneNumberRequired = validators.phoneNumberRequired(phoneNumberRequiredMessage);

    //birthdate select
    const birthdateLabel = intl.formatMessage({
      id: 'SignupForm.birthDateSelectLabel',
    });
    const birthdatePlaceholder = intl.formatMessage({
      id: 'SignupForm.birthDateSelectPlaceholder',
    });
    const birthdateRequiredMessage = intl.formatMessage(
      {
        id: 'SignupForm.birthDateSelectRequired',
      },
      { minValue: minimumAgeRequired }
    );
    const birthdateValidator = validators.composeValidators(
      validators.required(birthdateRequiredMessage),
      validators.isDateAboveMinValue(birthdateRequiredMessage, minimumAgeRequired)
    );

    //otp
    const otpPlaceholder = intl.formatMessage({
      id: 'SignupForm.otpPlaceholder',
    });
    const otpRequiredMessage = intl.formatMessage({
      id: 'SignupForm.otpRequired',
    });
    // const otpInvalidMessage = intl.formatMessage({
    //   id: 'SignupForm.invalidOtp',
    // });
    const otpTouched = !!otp && !!customOtpErrTextId;
    const customOtpErrText = !!customOtpErrTextId && intl.formatMessage({ id: customOtpErrTextId });
    const otpValidator = validators.composeValidators(
      validators.required(otpRequiredMessage)
      // validators.isValidOtp(otpInvalidMessage, refOtp)
    );

    // worker address
    const addressLabel = intl.formatMessage({
      id: 'SignupForm.workerAdrressLabel',
    });
    const addressPlaceholder = intl.formatMessage({
      id: 'SignupForm.workerAdrressPlaceholder',
    });
    const postalLabel = intl.formatMessage({
      id: 'SignupForm.workerPostalLabel',
    });
    const postalPlaceholder = intl.formatMessage({
      id: 'SignupForm.workerPostalPlaceholder',
    });
    const addressRequiredMessage = intl.formatMessage({
      id: 'SignupForm.workerAdrressRequired',
    });
    const addressRequired = validators.addressRequired(addressRequiredMessage);

    // worker aggrement
    const workerAgrementLabel = intl.formatMessage({
      id: 'SignupForm.workerAgrementLabel',
    });

    const loginLink = (
      <NamedLink name="LoginPage" className={css.loginLink}>
        <FormattedMessage id="TopbarDesktop.login" />
      </NamedLink>
    );

    const termsLink = (
      <NamedLink name="TermsOfServicePage" className={css.termsLink}>
        <FormattedMessage id="SignupForm.termsAndConditionsLinkText" />
      </NamedLink>
    );

    const policyLink = (
      <NamedLink name="PrivacyPolicyPage" className={css.termsLink}>
        <FormattedMessage id="SignupForm.policyLinkText" />
      </NamedLink>
    );

    const contactUsLink = (
      <NamedLink name="ContactUsPage" className={css.termsLink}>
        <FormattedMessage id="SignupForm.contactusLinkText" />
      </NamedLink>
    );
    const handleResendOtp = e => {
      this.setState({ otpResend: true });
      this.requestForOtp().then(() => {
        setTimeout(() => {
          this.setState({ otpResend: false });
        }, 1300);
      });
    };

    return (
      <Form className={classes} onSubmit={this.handleSubmit}>
        {/*<FormSpy
          subscription={{ values: true, active: true }}
          onChange={this.handleFormSpyChange}
    />*/}
        {this.state.signStep === 0 && (
          <div className={css.formTitle}>
            <h1 className={css.heading}>
              <FormattedMessage id="SignupForm.Heading" />
            </h1>
            <h3 className={css.subHeading}>
              <FormattedMessage id="SignupForm.subHeading" values={{ loginLink }} />
            </h3>
          </div>
        )}
        {this.state.signStep == 0 ? (
          <React.Fragment>
            <div className={css.supportingDocWrapper}>
              {/*<h3 className={css.header}>
                {intl.formatMessage({ id: 'SignupForm.supportingDocHeader' })}
        </h3>*/}
              <div className={css.allowedOption}>
                <div className={css.text}>
                  {intl.formatMessage({ id: 'SignupForm.allowedWorkerLabel' })}
                </div>
                <CustomRadioButton
                  name="workerAllowed"
                  onChange={this.handleWorkerAllowedChange}
                  radioValues={Object.values(workerAllowedOptions)}
                  id={workerAllowedOptionsId}
                  withForm={false}
                  formClassName={css.option}
                  values={values}
                  radioSelectedInputClassName={classNames({
                    [css.notAllowedOption]: workerAllowed === workerAllowedOptions.no.value,
                  })}
                />
              </div>
              <div className={classNames(css.allowedOption, css.columnOption)}>
                <div className={css.optionContent}>
                  <div className={css.text}>
                    {intl.formatMessage({ id: 'SignupForm.birthDateLabel' })}
                  </div>
                  <CustomRadioButton
                    name="age16Plus"
                    onChange={this.handleAge16PlusChange}
                    radioValues={Object.values(age16PlusOptions)}
                    id={age16PlusOptionsId}
                    withForm={false}
                    formClassName={css.option}
                    values={values}
                    radioSelectedInputClassName={classNames({
                      [css.notAllowedOption]: age16Plus === age16PlusOptions.no.value,
                    })}
                  />
                </div>

                {/* {age16Plus === age16PlusOptions.yes.value && (
                  <FieldDateInput
                    name="birthdate"
                    id={birthdateId}
                    placeholderText={birthdatePlaceholder}
                    label={birthdateLabel}
                    validate={birthdateValidator}
                    className={textfield}
                    errorClassName={errorTextField}
                    isOutsideRange={date => moment().diff(date, 'days') <= 0}
                    displayFormat="DD/MM/YYYY"
                    userNativeLang={userNativeLang}
                  />
                )} */}
              </div>
              <div className={css.allowedOption}>
                <div className={css.text}>
                  {intl.formatMessage({ id: 'SignupForm.drivingLicenseLabel' })}
                </div>
                <CustomRadioButton
                  name="drivingLicense"
                  onChange={this.handleDrivingLicenseChange}
                  radioValues={Object.values(drivingLicenseOptions)}
                  id={drivingLicenseOptionsId}
                  withForm={false}
                  formClassName={css.option}
                  values={values}
                  radioSelectedInputClassName={classNames({
                    [css.notAllowedOption]: drivingLicense === drivingLicenseOptions.no.value,
                  })}
                />
              </div>
            </div>
            <div>
              <div className={css.row}>
                <FieldTextInput
                  className={textfield}
                  errorClassName={errorTextField}
                  type="text"
                  id={firstNameId}
                  name="fname"
                  autoComplete="given-name"
                  label={firstNameLabel}
                  placeholder={firstNamePlaceholder}
                  validate={firstNameRequired}
                />
                <FieldTextInput
                  className={textfield}
                  errorClassName={errorTextField}
                  type="text"
                  id={lastNameId}
                  name="lname"
                  autoComplete="family-name"
                  label={lastNameLabel}
                  placeholder={lastNamePlaceholder}
                  validate={lastNameRequired}
                />
              </div>
              <div className={css.row}>
                <FieldTextInput
                  className={textfield}
                  errorClassName={errorTextField}
                  type="email"
                  id={emailId}
                  name="email"
                  autoComplete="email"
                  label={emailLabel}
                  placeholder={emailPlaceholder}
                  validate={emailValidator}
                  key={refEmail}
                />
                <FieldPhoneNumberInputWithDialCode
                  name="phoneNumber"
                  id={phoneNumberId}
                  label={phoneNumberLabel}
                  placeholder={phoneNumberPlaceholder}
                  validate={phoneNumberRequired}
                  className={textfield}
                  errorClassName={errorTextField}
                />
              </div>
              <div className={css.row}>
                <FieldPassword
                  className={classNames(css.password, textfield)}
                  errorClassName={errorTextField}
                  id={passwordId}
                  name="password"
                  autoComplete="new-password"
                  label={passwordLabel}
                  placeholder={passwordPlaceholder}
                  validate={passwordValidators}
                  passwordCheckRefValues={[fname, lname, email]}
                />
                <FieldPassword
                  className={classNames(css.password, textfield)}
                  errorClassName={errorTextField}
                  id={confirmPasswordId}
                  name="confirmPassword"
                  label={confirmPasswordLabel}
                  placeholder={confirmPasswordPlaceholder}
                  validate={confirmPasswordValidators}
                  passwordCheckRefValues={[fname, lname, email]}
                  refValue={password}
                />
              </div>
              <FieldAddress
                id={workerAddressId}
                name="workerAddress"
                addressLabel={addressLabel}
                addressPlaceholder={addressPlaceholder}
                postalLabel={postalLabel}
                postalPlaceholder={postalPlaceholder}
                className={classNames(textfield, css.AddressDiv)}
                errorClassName={errorTextField}
                validate={addressRequired}
                userNativeLang={userNativeLang}
              />
            </div>
            <div className={css.langDiv}>
              <FieldPerferredLang
                id={preferredLangId}
                userNativeLang={userNativeLang}
                name="preferredLang"
                className={textfield}
                errorClassName={errorTextField}
              />
            </div>

            <div className={css.WorkerAgreemnt}>
              <FieldCheckbox
                name="workerAgrement"
                id={workerAgreementId}
                label={workerAgrementLabel}
                value={workagredOnTerms}
                className={textfield}
              />
            </div>

            <FieldRecaptcha
              id={recaptchaId}
              name="recaptchaStatus"
              enableRecaptcha={!isFormOtherFieldInvalid}
              onChange={this.handleRecaptchStatusChange}
              {...reacaptchaInitialValueMaybe}
            />
          </React.Fragment>
        ) : this.state.signStep === 1 ? (
          <React.Fragment>
            <div>
              <FieldWorkerJobCategory
                formApi={formApi}
                id={jobCategoryId}
                name="jobCategories"
                userNativeLang={userNativeLang}
                titleClassName={css.workerJobCategoryTitle}
                values={jobCategories}
                isRequired={true}
                valuesFromForm={values}
              />
              <div className={css.tellus}>
                <FormattedMessage id="SignupForm.tellUs" />
              </div>
              <div>
                <FieldWorkerExperience
                  id={jobExpId}
                  formApi={formApi}
                  name="jobExperiences"
                  userNativeLang={userNativeLang}
                  onManageDisableScrolling={onManageDisableScrolling}
                />
              </div>
              <div>
                <FieldPermitAndCertificate
                  id={certificateId}
                  formApi={formApi}
                  userNativeLang={userNativeLang}
                  name="permitsAndCertificates"
                  formError={error}
                />
              </div>
              {/* <div>
                <FieldPerferredLang
                  id={preferredLangId}
                  userNativeLang={userNativeLang}
                  name="preferredLang"
                  className={textfield}
                  errorClassName={errorTextField}
                />
              </div> */}
              <div>
                <FieldReference
                  id={referId}
                  formApi={formApi}
                  userNativeLang={userNativeLang}
                  name="references"
                  formError={error}
                />
              </div>
            </div>
          </React.Fragment>
        ) : null}

        <div className={css.bottomWrapper}>
          {!isEmailTakenError && signupErrorMessage}
          <div className={css.btnWrapper}>
            <PrimaryButton
              type="submit"
              inProgress={
                (submitInProgress || this.state.isUserCreateInProgress) && !this.state.showOtpModal
              }
              disabled={submitDisabled || this.state.showOtpModal}
              className={css.submitBtn}
            >
              <FormattedMessage
                id={this.state.signStep === 0 ? 'SignupForm.signUp' : 'SignupForm.signUpFinish'}
              />
            </PrimaryButton>
            {this.state.signStep === 0 ? (
              <InlineTextButton
                type="button"
                className={css.cancelBtn}
                onClick={this.handleOnCancelBtnClick}
              >
                <FormattedMessage id="SignupForm.signUpCancel" />
              </InlineTextButton>
            ) : (
              <InlineTextButton
                type="button"
                className={css.cancelBtn}
                onClick={this.handleOnSkipBtnClick}
              >
                <FormattedMessage id="SignupForm.signUpSkip" />
              </InlineTextButton>
            )}
          </div>
          {/*className={css.bottomWrapperText}*/}

          <p className={css.helperTextWrapper}>
            {this.state.signStep === 0 && (
              <span className={css.termsText}>
                <FormattedMessage
                  id="SignupForm.termsAndConditionsAcceptText"
                  values={{ termsLink, policyLink }}
                />
              </span>
            )}
            <span>
              <FormattedMessage id="SignupForm.contactusText" values={{ contactUsLink }} />
            </span>
          </p>
          {this.state.signStep === 0 && <div>{socialLoginButtonsMaybe}</div>}
        </div>
        <FieldCalendlyMeet
          userNativeLang={userNativeLang}
          id={interviewDetailsId}
          name="interviewDetails"
          initCalendly={this.state.showCalendlyModal}
          onChange={this.handleCalendlyMeetChange}
          inviteeDetails={interviewDetailsMaybe}
        />
        <Modal
          id="CustomerSignup.verifyotp"
          isOpen={this.state.showOtpModal}
          onClose={this.checkAndHideOtpModal}
          onManageDisableScrolling={onManageDisableScrolling}
          showCloseButtonMessage={false}
        >
          {this.state.showOtpModal && (
            <div className={css.otpContentWrapper}>
              <div className={css.contentHeading}>
                <h3 className={css.heading}>
                  {intl.formatMessage({ id: 'SignupForm.otpHeading' })}
                </h3>
                <p className={css.subHeading}>
                  {intl.formatMessage({ id: 'SignupForm.otpSubheading' })}
                </p>
                <div>
                  <div className={css.changeNumberWrapper}>
                    <span className={css.changeNumberText}>{phoneNumberWithDialCode}</span>
                    <InlineTextButton
                      type="button"
                      className={css.changeNumberBtn}
                      onClick={this.checkAndHideOtpModal}
                    >
                      {intl.formatMessage({ id: 'SignupForm.changeNumberText' })}
                    </InlineTextButton>
                  </div>
                  <FieldNumberInput
                    id="otp"
                    name="otp"
                    placeholder={otpPlaceholder}
                    validate={otpValidator}
                    className={textfield}
                    errorClassName={errorTextField}
                    key={refOtp}
                    onChange={e => {
                      formApi.batch(() => {
                        formApi.change('customOtpErrTextId', '');
                        formApi.change('otp', e);
                      });
                    }}
                    customErrorText={otpTouched ? customOtpErrText : null}
                  />
                  <div className={css.noOtpWrapper}>
                    {this.state.otpResend ? (
                      <FormattedMessage id="LoginForm.resendingOtpInfo" />
                    ) : (
                      <>
                        <span className={css.noOtpText}>
                          {intl.formatMessage({ id: 'SignupForm.noOtpText' })}
                        </span>
                        <InlineTextButton
                          type="button"
                          className={css.noOtpBtn}
                          // onClick={this.requestForOtp}
                          onClick={handleResendOtp}
                        >
                          {intl.formatMessage({ id: 'SignupForm.resendOtpText' })}
                        </InlineTextButton>
                      </>
                    )}
                  </div>
                </div>

                <SecondaryButton
                  type="button"
                  className={css.otpCheckBtn}
                  inProgress={this.state.otpValidationInProgress}
                  onClick={this.verifyOtp}
                  disabled={!values?.otp || customOtpErrText}
                >
                  {intl.formatMessage({ id: 'SignupForm.otpHeading' })}
                </SecondaryButton>
              </div>
            </div>
          )}
        </Modal>
        <Modal
          id="customersignup.notallowed"
          className={css.notallowedModal}
          isOpen={this.state.showNotAllowedModal}
          onClose={this.setShowNotAllowedModal.bind(this, false)}
          onManageDisableScrolling={onManageDisableScrolling}
          showCloseButtonMessage={false}
        >
          {this.state.showNotAllowedModal && (
            <div className={css.notAllowedWrapper}>
              <h3 className={css.header}>
                {intl.formatMessage({ id: this.state.notAllowedHeadingId })}
              </h3>
              <p className={css.body}>{intl.formatMessage({ id: this.state.notAllowedBodyId })}</p>
              <SecondaryButton
                type="button"
                className={css.btn}
                onClick={this.setShowNotAllowedModal.bind(this, false)}
              >
                {intl.formatMessage({ id: 'SignupForm.notAllowedBtnText' })}
              </SecondaryButton>
            </div>
          )}
        </Modal>
      </Form>
    );
  }
}
